export default __webpack_public_path__ + "static/media/Jocelyn.a57aff92.jpg";